import {useEffect, useState} from 'react';

const TICK_INTERVAL_MS = 1000;

const secondsSince = (startedAt: number): number => {
  return Math.floor((Date.now() - startedAt) / TICK_INTERVAL_MS);
};

export function useElapsedSeconds(startedAt: number | null): number {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    if (!startedAt) {
      setElapsedSeconds(0);

      return;
    }

    setElapsedSeconds(secondsSince(startedAt));

    const interval = setInterval(() => {
      setElapsedSeconds(secondsSince(startedAt));
    }, TICK_INTERVAL_MS);

    return (): void => {
      clearInterval(interval);
    };
  }, [startedAt]);

  return elapsedSeconds;
}
